import { z } from "zod";

export const MIMETypeSchema = z.object({
    id: z.number(),
    MIMEtype: z.string().optional(),
    file_ending: z.string().optional(),
});

export type IMIMEType = z.infer<typeof MIMETypeSchema>;
